import React, { useRef } from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import Avatar from "@arctheme-components/elements/Avatar/Avatar";
import { StarIcon } from "../TestimonialStar/TestimonialStar";
import { Image } from "@arctheme-components/elements/Image/Image";
import CarouselNavigation from "@arctheme-components/blocks/NavigationElements/CarouselNavigation";
import clsx from "clsx";

const CarouselLayout = ({ settings, blocks }) => {

  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const { section: {
    content_alignment_desktop,
    content_alignment_mobile,
    padding_left_right_mobile,
    padding_left_right_desktop,
    title,
    subtext,
    is_full_width_blocks
  }, globals } = settings;

  const carouselRef = useRef(null);
  const showAvatar = false;
  const paddingRight = `pr-[${padding_left_right_mobile}px] lg:pr-[${padding_left_right_desktop}px]`;
  const contentAlignment = isMobile
    ? content_alignment_mobile
    : content_alignment_desktop;

  return (
    <div className={"testimonials"}>
      <div className={`testimonials-top w-full ${paddingRight} text-${contentAlignment}`}>
        <Headings text={title} type={isMobile ? "h4" : "h2"} />
        <Paragraph text={subtext} type={isMobile ? "b3" : "b2"} />
      </div>

      <div
        className={`testimonials__container carousel ${is_full_width_blocks ? paddingRight : ''}`}
        {...{
          "x-data": "extended_carousel",
          "x-init":
            "$nextTick(() => { initialise(true, false, false, false, false, 'test') })",
        }}
        x-ref="carousel"
        ref={carouselRef}
      >
        {blocks.map((blockItem, index) => (
          <div
            key={`carousel-item review-${index}`}
            className={clsx('testimonial', {
              'full-width-blocks': is_full_width_blocks,
              'has-company-logo': blockItem.settings.company_logo
            })}
          >
            {blockItem.settings.company_logo && (
              <div className={`testimonial__company-logo`}>
                <Image
                  imageUrl={blockItem.settings.company_logo}
                  alt={"review_image"}
                />
              </div>
            )}

            {(blockItem.settings.star_rating > 0) &&
              <div className={"testimonial__ratings"}>
                {(() => {
                  let rows: any = [];
                  for (let i = 0; i < blockItem.settings.star_rating; i++) {
                    // @ts-ignore
                    rows.push(
                        <React.Fragment key={`star-${i}`}>
                            <i className="icon rating-star"></i>
                        </React.Fragment>
                    );
                  }
                  return rows;
                })()}
              </div>
            }

            <div
              className={`testimonial__quote ${isMobile ? "b3" : "b2"}`}
              dangerouslySetInnerHTML={{
                __html: blockItem.settings.blurb.replace(/\n/g, "<br />"),
              }}
            />

            {(showAvatar || blockItem.settings.image || blockItem.settings.author || blockItem.settings.subtext) &&
              <div className={"testimonial-data"}>
                {showAvatar && (
                  <div className="testimonial__image">
                    <Avatar
                      imageUrl={"https://via.placeholder.com/150"}
                      size={"50px"}
                    />
                  </div>
                )}

                {blockItem.settings.image && (
                  <div
                    className={`testimonial__image ${isMobile ? "hidden" : "flex"}`}
                  >
                    <Image
                      imageUrl={blockItem.settings.image}
                      alt={"review_image"}
                    />
                  </div>
                )}

                <div className={`testimonial__details`}>
                  {blockItem.settings.author && (
                    <p className="testimonial__author bfb">
                      {blockItem.settings.author}
                    </p>
                  )}
                  {blockItem.settings.subtext && (
                    <p className="testimonial__subtext">
                      {blockItem.settings.subtext}
                    </p>
                  )}
                </div>
              </div>
            }
          </div>
        ))}
      </div>

      <div
        className={`section-bottomrow flex flex-row justify-between items-center w-full mt-3 lg:mt-[36px] ${paddingRight}`}
      >
        <CarouselNavigation
            shiftPageDots={true}
            carouselRef={carouselRef}
            icons={globals.carousel_icons}
            size={globals.carousel_icons?.carousel_navigation_arrow_size}
        />
      </div>
    </div>
  );
};

export default CarouselLayout;
